/**
 * Returns if the given {@link value} is empty
 */
export const isEmpty = (value: string): boolean => {
  return value === "";
};
